import { httpV2 } from "@/api";
/**
 * Solicita as configurações de sinais de tendência para um conjunto de ativos(API v2).
 * @param {object} model Contém o array generatingUnitsMonitoringElementsIds e o flag onlyCalculated.
 * @returns Conjunto de sinais de tendência de suas respectivas turbinas.
 */
const GetFrequencyTrendSignalSettingsByAssetsMonitoringElements = async function(model)
{
	const ids = (model.generatingUnitsMonitoringElementsIds || []).map(m => m.id);

	const body = {
		generatingUnitsMonitoringElementsIds: ids,
		onlyCalculated:                       model.onlyCalculated ?? false,
	};

	const response = await httpV2.post("/FrequencyTrendSignalSettings", body);

	return response;
};

export default { GetFrequencyTrendSignalSettingsByAssetsMonitoringElements };